// Fire-and-forget beacon to log outbound clicks to schoolforcommunitylearning.org
// with user identity (if a session exists). Never blocks navigation.
import { API } from "../state/AppContext";

export function logSiteClick(ctx, linkType, destinationUrl) {
  try {
    const body = JSON.stringify({
      user_id: ctx?.user?.id || null,
      link_type: linkType,
      destination_url: destinationUrl,
      source_path: ctx?.sourcePath || "",
      language: ctx?.lang || "en",
      utm_content: ctx?.utmContent || "",
      utm_source: ctx?.utmSource || "",
      utm_campaign: ctx?.utmCampaign || "",
      utm_medium: ctx?.utmMedium || "",
    });
    // Prefer sendBeacon (best for outbound navigation), fall back to fetch keepalive
    const url = `${API}/site-clicks`;
    if (navigator.sendBeacon) {
      const blob = new Blob([body], { type: "application/json" });
      navigator.sendBeacon(url, blob);
    } else {
      fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body,
        keepalive: true,
      }).catch(() => {});
    }
  } catch {
    // Never let click tracking block navigation
  }
}
